import React, { FunctionComponent } from 'react'
import { Company } from '../../../pages/DashBoard/DashBoardScreen'
import { randomID } from '../../../redux/misc/helpers'
import { ProductData } from '../../../redux/requests/products/product.types'
import * as S from './styled'

type OwnProps = {
  productData: ProductData[]
  setHouse: React.Dispatch<React.SetStateAction<number>>
  house: number
  packeryFilter: Company
}

type Props = OwnProps

export const HouseDropDown: FunctionComponent<Props> = ({
  setHouse,
  productData,
  house,
  packeryFilter,
}) => {
  const houses = Array.from(
    new Set(
      productData
        .map(item => {
          if (packeryFilter === item.buyer) {
            return item.houseId
          }
          return ''
        })
        .filter(item => item),
    ),
  )
  function changeHandler(event: any) {
    const value = event.target.options[event.target.options.selectedIndex].value

    setHouse(value)
  }

  return (
    <S.Card>
      <S.Text>Avdelning:</S.Text>
      <S.DropDown onChange={changeHandler} value={house}>
        <option value={0}>Alla</option>
        {houses.map(item => (
          <option key={randomID()} value={item}>
            {item}
          </option>
        ))}
      </S.DropDown>
    </S.Card>
  )
}

export default HouseDropDown
